"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const shared_1 = require("../shared");
const material_1 = require("@mui/material");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const material_table_1 = __importDefault(require("material-table"));
const moment_1 = __importDefault(require("moment"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
const exceljs_1 = __importDefault(require("exceljs"));
const file_saver_1 = require("file-saver");
const PersonSearch_1 = __importDefault(require("@mui/icons-material/PersonSearch"));
const Alert = React.forwardRef(function Alert(props, ref) {
    return (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ elevation: 6, ref: ref, variant: 'filled' }, props));
});
const Courses = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    let [tableData, setTableData] = React.useState([]);
    const [courseEnum, setcourseEnum] = React.useState({});
    const [studentEnum, setStudentEnum] = React.useState({});
    const [studentEnrollDetail, SetStudentEnrollDetail] = React.useState({});
    const [courseData, SetCourseData] = React.useState([]);
    const [action, SetAction] = React.useState('');
    const [snackBarDetails, setSnackBarDetails] = React.useState({
        open: false,
        message: '',
        severity: 'success',
    });
    const [currentRowData, SetCurrentRowData] = React.useState({});
    const [anchorAddEl, setAnchorAddEl] = React.useState(null);
    const [studentData, setStudentData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const defaultMaterialTheme = (0, material_1.createTheme)({});
    const [confirmDialogData, SetConfirmDialogData] = React.useState({
        dialogOpen: false,
        dialogTitle: '',
        dialogMessage: '',
        dialogSubMessage: '',
        dialogBtnYes: 'Yes',
        dialogBtnNo: 'No',
        handleDlgYes: null,
        handleDlgNo: null,
    });
    const popoverTheme = (0, material_1.createTheme)({
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        padding: 10,
                        // borderRadius: '100px',
                        boxShadow: '10px 10px 5px 0px rgba(0,0,0,0.75)',
                    },
                },
            },
        },
    });
    React.useEffect(() => {
        initGet();
    }, []);
    const constructAddress = (matchingObj) => {
        if (!matchingObj) {
            return '';
        }
        const addressParts = [];
        if (matchingObj.studentAddress1) {
            addressParts.push(matchingObj.studentAddress1);
        }
        if (matchingObj.studentAddress2) {
            addressParts.push(matchingObj.studentAddress2);
        }
        if (matchingObj.studentCity) {
            addressParts.push(matchingObj.studentCity);
        }
        if (matchingObj.studentState) {
            addressParts.push(matchingObj.studentState);
        }
        if (matchingObj.studentCountry) {
            addressParts.push(matchingObj.studentCountry);
        }
        if (matchingObj.studentPostCode) {
            addressParts.push(matchingObj.studentPostCode);
        }
        const fullAddress = addressParts.join(', ');
        return fullAddress;
    };
    const initGet = async () => {
        const user = await (0, shared_1.getCurrentUser)();
        const admin = await (0, shared_1.checkAdminUser)(user === null || user === void 0 ? void 0 : user.email);
        if (admin) {
            setIsLoading(true);
            const [userList, regUserList, courseData, schoolName] = await Promise.all([
                (0, shared_1.getAllUser)(),
                (0, shared_1.getAllRegisterUser)(),
                (0, shared_1.getStrapiData)(`courses?&populate=*&pagination[pageSize]=10000&sort=displayOrder:asc`),
                (0, shared_1.getStrapiData)(`schools?&pagination[pageSize]=10000`),
            ]);
            const schoolMap = {};
            schoolName.forEach((school) => {
                schoolMap[school.id] = school.attributes.name;
            });
            const studentDetails = (userList || []).map((obj1) => {
                const matchingObj = (regUserList || []).find((obj2) => obj2.userId === obj1.id);
                if (matchingObj) {
                    // const studentSchoolName = schoolMap[matchingObj.studentSchool];
                    // const address = constructAddress(matchingObj);
                    // return { ...obj1, ...matchingObj, studentSchoolName, address };
                    return Object.assign(Object.assign({}, obj1), matchingObj);
                }
                else {
                    return obj1;
                }
            });
            setStudentData(studentDetails);
            SetCourseData(courseData);
            const tempCourseEnum = {};
            const tempStudentEnum = {};
            courseData.forEach((course) => {
                tempCourseEnum[course.id] = course.attributes ? course.attributes.name : '';
            });
            regUserList.forEach((user) => {
                tempStudentEnum[user.userId] = `${user.studentFirstName} ${user.studentLastName}`;
            });
            setcourseEnum(tempCourseEnum);
            setStudentEnum(tempStudentEnum);
            generateReportData(studentDetails, courseData, true);
            setIsLoading(false);
        }
    };
    const generateReportData = (studentsDetail, courses, isInitRender) => {
        let studentCourseDetails = [];
        (courses || []).forEach((course) => {
            var _a;
            const students = (studentsDetail || []).filter((obj2) => obj2.enrolledCourses && obj2.enrolledCourses.includes(course.id));
            course.courseName = course.attributes ? course.attributes.name : '';
            course.courseCode = course.attributes ? (_a = course.attributes) === null || _a === void 0 ? void 0 : _a.code : '';
            course.startDate = course.attributes ? course.attributes.startDate : '';
            course.endDate = course.attributes ? course.attributes.endDate : '';
            course.courseId = course.id;
            course.numOfStudents = students.length;
            studentCourseDetails.push(course);
            if (students.length > 0) {
                (students || []).forEach((student) => {
                    studentCourseDetails.push(Object.assign({ isChild: true, courseId: course.courseId, studentCourseId: course.courseId }, student));
                });
            }
            if (studentCourseDetails && studentCourseDetails.length > 0 && isInitRender) {
                setTableData(studentCourseDetails);
            }
        });
        return studentCourseDetails;
    };
    const handleAddStdClick = (event, rowData) => {
        SetAction('Add');
        setAnchorAddEl(event.currentTarget);
        SetStudentEnrollDetail(Object.assign(Object.assign({}, studentEnrollDetail), { courseId: rowData.courseId }));
        SetCurrentRowData(rowData);
    };
    const handleEditStdClick = (event, rowData) => {
        SetAction('Edit');
        setAnchorAddEl(event.currentTarget);
        SetStudentEnrollDetail(Object.assign(Object.assign({}, studentEnrollDetail), { userId: rowData.userId }));
        SetCurrentRowData(rowData);
    };
    const handleSnackBarClose = () => {
        setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: false }));
    };
    const handleDeleteStdClick = (event, rowData) => {
        SetCurrentRowData(rowData);
        SetConfirmDialogData({
            dialogOpen: true,
            dialogTitle: 'Remove Student',
            dialogMessage: 'Are you sure you want to remove this student from the course?',
            dialogSubMessage: '',
            dialogBtnYes: 'Yes',
            dialogBtnNo: 'No',
            handleDlgYes: () => {
                return new Promise(async (resolve, reject) => {
                    const studentId = rowData.userId;
                    const oldCoureId = rowData.courseId;
                    let enrolledCourses = rowData.enrolledCourses;
                    var index = enrolledCourses.indexOf(oldCoureId);
                    if (~index) {
                        enrolledCourses.splice(index, 1);
                        let res = await (0, shared_1.updateUserDetail)(studentId, { enrolledCourses });
                        if (res) {
                            const res = await (0, shared_1.updateCourseDetails)(oldCoureId, 'Delete');
                            if (res) {
                                setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Deleted successfully!', severity: 'success' }));
                                removeByAttr(tableData, 'userId', 'courseId', rowData.userId, rowData.courseId);
                            }
                        }
                    }
                    resolve();
                });
            },
            handleDlgNo: () => {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            },
        });
    };
    var removeByAttr = (arr, attr, attr1, value, value1) => {
        var i = arr.length;
        while (i--) {
            if (arr[i] && arr[i].hasOwnProperty(attr) && arr[i].hasOwnProperty(attr1) && arr[i][attr] === value && arr[i][attr1] === value1) {
                arr.splice(i, 1);
            }
        }
    };
    var updateEntrolledCourses = (student, course, enrolledCourses) => {
        let tempStudentArray = [];
        let tempCourseArray = [];
        student['enrolledCourses'] = enrolledCourses;
        tempStudentArray.push(student);
        tempCourseArray.push(course);
        let rptData = generateReportData(tempStudentArray, tempCourseArray);
        let result = rptData.find((res) => res.isChild);
        tableData.push(result);
    };
    const handleAddStdClose = (event) => {
        setAnchorAddEl(null);
        SetStudentEnrollDetail({});
        SetCurrentRowData({});
    };
    const resetData = () => {
        SetConfirmDialogData({
            dialogOpen: false,
            dialogTitle: '',
            dialogMessage: '',
            dialogSubMessage: '',
            dialogBtnYes: 'Yes',
            dialogBtnNo: 'No',
            handleDlgYes: null,
            handleDlgNo: null,
        });
    };
    const handleStudentEnrollment = async () => {
        let student = studentData.find((std) => std.userId === studentEnrollDetail.userId);
        let course = courseData.find((course) => course.id === Number(studentEnrollDetail.courseId));
        if (action === 'Add') {
            if (student.enrolledCourses) {
                if (!student.enrolledCourses.includes(Number(studentEnrollDetail.courseId))) {
                    let enrolledCourses = student.enrolledCourses;
                    enrolledCourses.push(studentEnrollDetail.courseId);
                    let res = (0, shared_1.updateUserDetail)(studentEnrollDetail.userId, { enrolledCourses });
                    if (res) {
                        try {
                            const res = await (0, shared_1.updateCourseDetails)(studentEnrollDetail.courseId, 'Add');
                            if (res) {
                                setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Added successfully!', severity: 'success' }));
                                updateEntrolledCourses(student, course, enrolledCourses);
                                handleAddStdClose();
                            }
                            else {
                                setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Error while adding the student!', severity: 'error' }));
                                handleAddStdClose();
                            }
                        }
                        catch (err) {
                            setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Error while adding the student!', severity: 'error' }));
                        }
                    }
                    else {
                        handleAddStdClose();
                        setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Error while adding the student!', severity: 'error' }));
                    }
                }
                else {
                    handleAddStdClose();
                    setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Student already entrolled for the same course!', severity: 'warning' }));
                }
            }
        }
        else if (action === 'Edit') {
            const studentId = studentEnrollDetail.userId;
            const newCoureId = studentEnrollDetail.courseId;
            const oldCoureId = currentRowData.courseId;
            let enrolledCourses = currentRowData.enrolledCourses;
            var index = enrolledCourses.indexOf(oldCoureId);
            if (~index) {
                if (!student.enrolledCourses.includes(Number(newCoureId))) {
                    enrolledCourses[index] = Number(newCoureId);
                    let res = await (0, shared_1.updateUserDetail)(studentId, { enrolledCourses });
                    if (res) {
                        const resRemove = await (0, shared_1.updateCourseDetails)(oldCoureId, 'Delete');
                        const resAdd = await (0, shared_1.updateCourseDetails)(newCoureId, 'Add');
                        if (resRemove && resAdd) {
                            setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Updated successfully!', severity: 'success' }));
                            removeByAttr(tableData, 'userId', 'courseId', studentId, oldCoureId);
                            // setTimeout(() => {
                            updateEntrolledCourses(student, course, enrolledCourses);
                            // }, 1000);
                            handleAddStdClose();
                        }
                        else {
                            setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Error while updating the student!', severity: 'error' }));
                            handleAddStdClose();
                        }
                    }
                    else {
                        setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Error while updating the student!', severity: 'error' }));
                        handleAddStdClose();
                    }
                }
                else {
                    setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Student already entrolled for the same course!', severity: 'warning' }));
                }
            }
        }
    };
    const { dialogOpen, dialogTitle, dialogMessage, dialogSubMessage, dialogBtnYes, dialogBtnNo, handleDlgYes, handleDlgNo } = confirmDialogData;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [isLoading && ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ justifyContent: 'center', alignItems: 'center', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(CircularProgress_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ style: { fontFamily: 'PoppinsMedium', fontSize: '1.5vmax', textAlign: 'center', color: 'black' } }, { children: "Please wait ..." }))] })) }))), (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, Object.assign({ theme: defaultMaterialTheme }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ id: 'myGrid', style: {
                        padding: '2vmax',
                        display: 'flex',
                    } }, { children: (0, jsx_runtime_1.jsx)(material_table_1.default, { style: { fontSize: '0.7vmax', overflowX: 'auto' }, title: 'Courses', columns: [
                            { title: 'Course Name', field: 'courseId', lookup: courseEnum, width: '20%', render: (rowData) => (!rowData.isChild ? rowData.courseName : '') },
                            { title: 'Course Code', field: 'courseCode', width: '20%', render: (rowData) => (!rowData.isChild ? rowData.courseCode : '') },
                            { title: 'Start Date', field: 'startDate', editable: 'never', render: (rowData) => (!rowData.isChild ? (0, moment_1.default)(rowData.startDate).format('MM/DD/YY') : '') },
                            { title: 'End Date', field: 'endDate', editable: 'never', render: (rowData) => (!rowData.isChild ? (0, moment_1.default)(rowData.endDate).format('MM/DD/YY') : '') },
                            { title: 'First Name', field: 'userId', editable: 'onAdd', lookup: studentEnum, render: (rowData) => (rowData.isChild ? rowData.firstName : '') },
                            { title: 'Last Name', field: 'lastName', editable: 'never' },
                            // { title: 'Student School', field: 'studentSchoolName', editable: 'never' },
                            { title: 'Student Email', field: 'email', editable: 'never' },
                            {
                                title: 'Student Phone',
                                field: 'studentCellNumber',
                                cellStyle: { minWidth: '8vw' },
                                editable: 'never',
                                render: (rowData) => `${(rowData === null || rowData === void 0 ? void 0 : rowData.studentPhCode) || ''} ${(rowData === null || rowData === void 0 ? void 0 : rowData.studentCellNumber) || ''}`,
                            },
                            { title: 'Parent Email', field: 'parent1EmailAddress', editable: 'never' },
                            {
                                title: 'Parent Phone',
                                field: 'parent1CellNumber',
                                cellStyle: { minWidth: '10vw' },
                                editable: 'never',
                                render: (rowData) => `${(rowData === null || rowData === void 0 ? void 0 : rowData.parent1PhCode) || ''} ${(rowData === null || rowData === void 0 ? void 0 : rowData.parent1CellNumber) || ''}`,
                            },
                            // { title: 'Address', field: 'address', editable: 'never' },
                        ], data: tableData, parentChildData: (row, rows) => rows.find((a) => a.courseId === Number(row.studentCourseId)), actions: [
                            (rowData) => !rowData.isChild && {
                                icon: 'add',
                                tooltip: 'Add Student',
                                onClick: (event, rowData) => {
                                    handleAddStdClick(event, rowData);
                                },
                            },
                            (rowData) => rowData.isChild && {
                                icon: 'edit',
                                tooltip: 'Change Course',
                                onClick: (event, rowData) => {
                                    handleEditStdClick(event, rowData);
                                },
                            },
                            (rowData) => rowData.isChild && {
                                icon: 'delete',
                                tooltip: 'Remove Student',
                                onClick: (event, rowData) => {
                                    handleDeleteStdClick(event, rowData);
                                },
                            },
                            (rowData) => rowData.isChild && {
                                icon: () => (0, jsx_runtime_1.jsx)(PersonSearch_1.default, {}),
                                tooltip: 'View Student Details',
                                onClick: (event, rowData) => {
                                    navigate(`/profile/${rowData.id}`);
                                },
                            },
                        ], options: {
                            paging: false,
                            sorting: true,
                            actionsColumnIndex: -1,
                            toolbarButtonAlignment: 'left',
                            maxBodyHeight: '75vh',
                            exportButton: { csv: true, pdf: false },
                            exportAllData: true,
                            exportCsv: async (columns, data) => {
                                const workbook = new exceljs_1.default.Workbook();
                                const worksheet = workbook.addWorksheet('Courses');
                                const headerRow = worksheet.addRow(columns.map((column) => column.title));
                                headerRow.font = { color: { argb: 'FFFFFF' }, bold: true };
                                headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '505050' } };
                                const addRow = (rowData, isChild) => {
                                    const row = worksheet.addRow(columns.map((columnDef) => {
                                        if (columnDef.field === 'courseId') {
                                            return rowData['courseName'];
                                        }
                                        else if (columnDef.field === 'userId') {
                                            return rowData['firstName'];
                                        }
                                        else {
                                            return rowData[columnDef.field];
                                        }
                                    }));
                                    if (isChild) {
                                        row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } };
                                    }
                                    else {
                                        row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'e6e6e6' } };
                                    }
                                };
                                const sortedData = data.sort((a, b) => a.courseId - b.courseId);
                                sortedData.forEach((parentRow) => {
                                    addRow(parentRow, false);
                                    if (parentRow.tableData && parentRow.tableData.childRows && parentRow.tableData.childRows.length > 0) {
                                        parentRow.tableData.childRows.forEach((childRow) => {
                                            addRow(childRow, true);
                                        });
                                    }
                                });
                                const buffer = await workbook.xlsx.writeBuffer();
                                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                (0, file_saver_1.saveAs)(blob, 'Courses.xlsx');
                            },
                            // columnsButton: true,
                            rowStyle: (row) => {
                                const rowStyling = {
                                    backgroundColor: '#e6e6e6',
                                };
                                if (row.isChild) {
                                    rowStyling.backgroundColor = '#FFFFFF';
                                }
                                return rowStyling;
                            },
                            headerStyle: {
                                backgroundColor: '#505050',
                                color: '#FFFF',
                                fontSize: '17px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                            },
                        } }) })) })), (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, Object.assign({ theme: popoverTheme }, { children: (0, jsx_runtime_1.jsx)(Popover_1.default, Object.assign({ open: Boolean(anchorAddEl), anchorEl: anchorAddEl, onClose: handleAddStdClose, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    }, transformOrigin: {
                        vertical: 'center',
                        horizontal: 'right',
                    }, BackdropProps: { invisible: false }, classes: { paper: 'MuiPopover-paper' } }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ direction: 'row', spacing: 1, container: true }, { children: [action === 'Edit' && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Autocomplete_1.default, { id: 'course-detail', getOptionLabel: (option) => option.label, onChange: (event, newValue) => {
                                        if (newValue && newValue.id) {
                                            SetStudentEnrollDetail(Object.assign(Object.assign({}, studentEnrollDetail), { courseId: newValue.id }));
                                        }
                                    }, options: Object.keys(courseEnum).map((key) => ({ label: courseEnum[key], id: key })), sx: { width: 300 }, renderInput: (params) => (0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({}, params, { label: 'Course' })) }) }))), action === 'Add' && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Autocomplete_1.default, { id: 'student-details', getOptionLabel: (option) => option.label, onChange: (event, newValue) => {
                                        if (newValue && newValue.id) {
                                            SetStudentEnrollDetail(Object.assign(Object.assign({}, studentEnrollDetail), { userId: newValue.id }));
                                        }
                                    }, options: Object.keys(studentEnum).map((key) => ({ label: studentEnum[key], id: key })), sx: { width: 300 }, renderInput: (params) => (0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({}, params, { label: 'Student' })) }) }))), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, style: { marginTop: 10 } }, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Save' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: handleStudentEnrollment, disabled: !(studentEnrollDetail.userId && studentEnrollDetail.courseId) }, { children: (0, jsx_runtime_1.jsx)(Check_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Close' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: handleAddStdClose }, { children: (0, jsx_runtime_1.jsx)(Clear_1.default, {}) })) }))] }))] })) })) })), (0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: dialogOpen, onClose: handleDlgNo, "aria-labelledby": 'alert-dialog-title', "aria-describedby": 'alert-dialog-description' }, { children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, Object.assign({ id: 'alert-dialog-title' }, { children: 'Delete Student?' })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: (0, jsx_runtime_1.jsx)(DialogContentText_1.default, Object.assign({ id: 'alert-dialog-description' }, { children: "Are you sure you want to remove this student from the course?" })) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: (event) => {
                                    if (handleDlgNo) {
                                        handleDlgNo()
                                            .then((data) => {
                                            resetData();
                                        })
                                            .catch(() => {
                                            resetData();
                                        });
                                    }
                                    else {
                                        resetData();
                                    }
                                }, size: 'small' }, { children: "No" })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: (event) => {
                                    if (handleDlgYes) {
                                        handleDlgYes()
                                            .then((data) => {
                                            resetData();
                                        })
                                            .catch(() => {
                                            resetData();
                                        });
                                    }
                                    else {
                                        resetData();
                                    }
                                }, size: 'small', autoFocus: true }, { children: "Yes" }))] })] })), (0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ spacing: 2, sx: { width: '100%' } }, { children: (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: snackBarDetails.open, autoHideDuration: 6000, onClose: handleSnackBarClose }, { children: (0, jsx_runtime_1.jsx)(Alert, Object.assign({ onClose: handleSnackBarClose, severity: snackBarDetails.severity, sx: { width: '100%' } }, { children: snackBarDetails.message })) })) }))] }));
};
exports.default = Courses;
